<template>
  <div class="info">
    <div style="margin: 16px 10px">
      <div class="
          van-cell van-cell--clickable van-cell--center van-cell--borderless
          van-contact-card--add
        " role="button" tabindex="0" @click="onAdd">
        <i class="van-icon van-icon-add-square van-cell__left-icon"></i>
        <div class="van-cell__value van-cell__value--alone van-contact-card__value">
          添加身份信息
        </div>
        <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
      </div>
    </div>

    <div v-for="item in list" :key="item.id" class="card-list" @click.stop="handleSelect(item)">
      <i class="van-icon van-icon-contact van-cell__left-icon"></i>
      <div class="van-cell__value van-cell__value--alone van-contact-card__value">
        <div style="padding: 1px 0">
          <span class="card-list-title">姓名</span>{{ item.name }}
        </div>
        <div style="padding: 1px 0">
          <span class="card-list-title">电话</span>{{ item.mobile }}
        </div>
        <div style="padding: 1px 0">
          <span class="card-list-title">身份证</span>{{ item.cardId }}
        </div>
      </div>
      <i class="van-icon van-icon-edit van-address-item__edit" @click.stop="onEdit(item)"></i>
    </div>
  </div>
</template>

<script>
import { getIdentityList } from "@/api/user";
import { Toast } from "vant";

export default {
  name: "info",
  data() {
    return {
      chosenAddressId: "1",
      list: [],
    };
  },
  created() {
    this.getInfoList();
  },
  methods: {
    async getInfoList() {
      let res = await getIdentityList();
      if (res.code === 0) {
        this.list = res.data;
      }
    },
    onAdd() {
      this.$router.push({ path: "/user-center-info-edit" });
    },
    onEdit(item, index) {
      budo_log.info("#77", item);
      let info = {
        identityId: item.identityId,
        name: item.name,
        mobile: item.mobile,
        cardId: item.cardId,
      };
      sessionStorage.setItem("info", JSON.stringify(info));
      this.$router.push({
        path: "/user-center-info-edit",
        query: {
          identityId: item.identityId,
        },
      });
    },

    handleSelect(val) {
      budo_log.info("#93 handleSelect", val);

      let identityList = JSON.parse(localStorage.getItem("bms.identity-list") || "[]")

      let ids = identityList.map((item) => {
        return item.cardId;
      })

      let count = sessionStorage.getItem("bms.goods-count");

      if (count !== "1" && ids.includes(val.cardId)) {
        Toast.fail("身份信息重复");
        return;
      }

      if (count === "1") {
        identityList = [
          {
            name: val.name,
            mobile: val.mobile,
            cardId: val.cardId,
          },
        ];
      } else {
        if (identityList.length >= count) {
          Toast.fail("人数已满");

          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
          return;
        }

        identityList.push({
          name: val.name,
          mobile: val.mobile,
          cardId: val.cardId,
        });
      }

      localStorage.setItem("bms.identity-list", JSON.stringify(identityList));
      this.$router.go(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  background: #f5f5f5;
  overflow: hidden;
}

.card-list {
  display: flex;
  align-items: center;
  padding: 16px;
  margin: 16px 10px;
  position: relative;
  font-size: 14px;
  background: #fff;

  &-title {
    display: inline-block;
    width: 56px;
    margin-right: 12px;
  }
}
</style>
